import { Flex, Text } from '@chakra-ui/react';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';

interface Props {
  reactions: ReactionListItem[];
  selectedReactionId: ID | null;
  selectReaction: (reaction: Reaction) => void;
  inactive?: boolean;
}

const ReactionsRow: FC<Props> = ({
  reactions,
  selectReaction,
  selectedReactionId,
  inactive = false,
}) => {
  return (
    <Flex flexWrap="wrap">
      {reactions.map((reaction) => (
        <Flex
          onClick={(e) => {
            if (inactive) return;
            e.stopPropagation();
            selectReaction(reaction.reaction);
          }}
          mr="8px"
          cursor={inactive ? undefined : 'pointer'}
          key={reaction.reaction.id}
          bgColor={
            selectedReactionId === reaction.reaction.id
              ? Color.Primary200
              : Color.Shade200
          }
          borderRadius="18px"
          h="30px"
          px="10px"
          alignItems="center"
        >
          <Text mr="2px">{reaction.reaction.emoji}</Text>
          <Text fontSize="14px">{reaction.total}</Text>
        </Flex>
      ))}
    </Flex>
  );
};

export default ReactionsRow;
